import { getCurrentMemberSubscription, getPrimaryMemberPaymentCard, logger } from '@vista/omnichannel-components-domain';
import { MemberPaymentCardWalletActionType as ActionType } from './action-type';
import { getMemberPaymentCardWalletNotificationType } from './get-member-payment-card-wallet-notification-type';
export const memberPaymentCardWalletActionReducer = (state, action) => {
    switch (action.type) {
        case ActionType.Loading:
            return Object.assign(Object.assign({}, state), { isLoading: true, hasFailedToLoad: false, showForm: false });
        case ActionType.FailedToLoad:
            return Object.assign(Object.assign({}, state), { isLoading: false, hasFailedToLoad: true });
        case ActionType.Loaded: {
            const subscriptionDetails = getCurrentMemberSubscription();
            const primaryCard = getPrimaryMemberPaymentCard();
            const memberPaymentCardWalletNotificationType = getMemberPaymentCardWalletNotificationType(subscriptionDetails, primaryCard, action.expiringSoonThresholdInMonths);
            return Object.assign(Object.assign({}, state), { isLoading: false, hasFailedToLoad: false, memberPaymentCardWalletNotificationType });
        }
        case ActionType.CloseModal:
            return Object.assign(Object.assign({}, state), { showModal: false, isLoading: false });
        case ActionType.OpenModal:
            return Object.assign(Object.assign({}, state), { showModal: true });
        case ActionType.AsyncCallStarted:
            return Object.assign(Object.assign({}, state), { disableActionButtons: true });
        case ActionType.AsyncCallCompleted:
            return Object.assign(Object.assign({}, state), { disableActionButtons: false });
        default: {
            logger.error(`Unknown MemberPaymentCardWalletAction ${action.type}.`);
            return state;
        }
    }
};
